import __request__ from "routing/request";
export function views(sort = "title", scope = "read", page = 1, per_page = 50, order = "asc", query, filters) {
  return __request__("GET", "/dashboards", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters, "scope": scope }, {
    "Accept": ["application/json"]
  });
}
